import Icon from '../../shared/components/Icons';
import { fmtDay } from '../../shared/data/common';

/** Insurance policy summary used on review, confirmation and booking details pages. */
export default function InsuranceSummary({ summary: s }) {
  return (
    <div className="sum">
      <div className="sum-media">
        <span className="transfer-icon sm"><Icon name="insurance" size={28} strokeWidth={1.5} /></span>
        <div>
          <span className="tag">{s.insurer}</span>
          <h3>{s.name} plan</h3>
          <span className="muted small">Medical cover up to <b>{s.cover}</b>{s.journey && <> · {s.journey}</>}</span>
        </div>
      </div>
      <div className="kv-grid">
        <div><span className="muted small">Travelling to</span><b>{s.region}</b>{s.validIn && <span className="muted small">Valid in {s.validIn}</span>}</div>
        <div><span className="muted small">Cover starts</span><b>{fmtDay(s.start)}</b></div>
        <div><span className="muted small">Cover ends</span><b>{fmtDay(s.end)}</b></div>
        <div><span className="muted small">Insured</span><b>{s.travellers} traveller{s.travellers > 1 ? 's' : ''} · {s.days} days</b></div>
      </div>
      {s.benefits?.length > 0 && (
        <div className="sum-foot">
          <span><Icon name="check" size={14} /> {s.benefits.join(' · ')}</span>
        </div>
      )}
    </div>
  );
}
